import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function Field({ id, label, value, onChange, error, disabled, hint, type = "text", placeholder }) {
  return (
    <div data-field={id}>
      <Label htmlFor={`bs-${id}`} className="text-xs text-slate-500">{label}</Label>
      <Input id={`bs-${id}`} type={type} value={value ?? ""} placeholder={placeholder} disabled={disabled} aria-invalid={!!error}
        onChange={(e) => onChange(e.target.value)} data-testid={`bs-${id}`} className={`mt-1 bg-white ${error ? "border-rose-400" : ""}`} />
      {error ? <p className="mt-1 text-xs text-rose-600" data-testid={`bs-${id}-error`}>{error}</p> : hint ? <p className="mt-1 text-[11px] text-slate-400">{hint}</p> : null}
    </div>
  );
}

export function SaveBar({ dirty, busy, onSave, onCancel, disabled, id }) {
  return (
    <div className="mt-6 flex items-center justify-end gap-2 border-t border-slate-100 pt-4">
      {dirty && <span className="mr-auto text-xs font-medium text-amber-600" data-testid={`${id}-unsaved`}>Unsaved changes</span>}
      <button type="button" disabled={!dirty || busy} onClick={onCancel} data-testid={`${id}-cancel`} className="rounded-full border border-slate-200 px-4 py-2 text-sm text-slate-600 transition-colors hover:bg-slate-50 disabled:opacity-40">Cancel</button>
      <button type="button" disabled={!dirty || busy || disabled} onClick={onSave} data-testid={`${id}-save`} className="rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-slate-700 disabled:opacity-40">{busy ? "Saving…" : "Save changes"}</button>
    </div>
  );
}

export const fieldErrors = (e) => e?.response?.data?.detail?.fields || {};
